import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "emailInput",
    "verificationButton", 
    "emailStatus",
    "resendButton",
    "verificationSection",
    "verificationInput",
    "verificationStatus",
    "submitButton"
  ]

  static values = {
    verificationPath: String,
  }

  connect() {
    // 서버에서 렌더링할 때 인증번호가 이미 발송된 상태인지 확인
    this.emailSent = !this.verificationSectionTarget.classList.contains('hidden')
    this.verificationSent = false
    
    // 인증하기 버튼 상태 설정
    if (this.emailSent) {
      this.verificationButtonTarget.disabled = false
    }
  }

  validateEmail() {
    const email = this.emailInputTarget.value
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
    
    if (email && emailRegex.test(email)) {
      this.verificationButtonTarget.disabled = false
      this.emailStatusTarget.textContent = ""
    } else {
      this.verificationButtonTarget.disabled = true
      if (email && !emailRegex.test(email)) {
        this.emailStatusTarget.textContent = "올바른 이메일 형식을 입력해주세요."
        this.emailStatusTarget.className = "text-sm text-red-600 dark:text-red-400"
      } else {
        this.emailStatusTarget.textContent = ""
      }
    }
  }

  validatePortfolio() {
    const portfolioLink = event.target.value
    const urlRegex = /^https?:\/\/.+/
    
    if (portfolioLink.trim() && !urlRegex.test(portfolioLink.trim())) {
      event.target.setCustomValidity("링크는 http:// 또는 https://로 시작해야 합니다.")
    } else {
      event.target.setCustomValidity("")
    }
  }

  async requestVerification() {
    const email = this.emailInputTarget.value
    
    if (!email) return
    
    this.verificationButtonTarget.disabled = true
    this.emailStatusTarget.textContent = "인증번호를 발송중입니다..."
    this.emailStatusTarget.className = "text-sm text-blue-600 dark:text-blue-400"
    
    try {
      const response = await fetch(this.verificationPathValue, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': document.querySelector('[name="csrf-token"]').content
        },
        body: JSON.stringify({ email: email })
      })
      
      const result = await response.json()
      
      if (response.ok) {
        this.emailSent = true
        this.emailStatusTarget.textContent = "인증번호가 발송되었습니다. (10분간 유효)"
        this.emailStatusTarget.className = "text-sm text-green-600 dark:text-green-400"
        this.resendButtonTarget.classList.remove('hidden')
        this.verificationSectionTarget.classList.remove('hidden')
        this.verificationInputTarget.focus()
        
        // 기존 인증번호 에러 메시지 지우기
        this.verificationStatusTarget.innerHTML = ""
        
        // 1분 후 재발송 버튼 활성화
        setTimeout(() => {
          this.verificationButtonTarget.disabled = false
        }, 60000)
      } else {
        this.emailStatusTarget.textContent = result.message || "인증번호 발송에 실패했습니다."
        this.emailStatusTarget.className = "text-sm text-red-600 dark:text-red-400"
        this.verificationButtonTarget.disabled = false
      }
    } catch (error) {
      this.emailStatusTarget.textContent = "네트워크 오류가 발생했습니다."
      this.emailStatusTarget.className = "text-sm text-red-600 dark:text-red-400"
      this.verificationButtonTarget.disabled = false
    }
  }

  async resendVerification() {
    // 기존 에러 메시지 지우기
    this.verificationStatusTarget.innerHTML = ""
    
    this.requestVerification()
  }

  submitForm(event) {
    // HTML5 validation이 먼저 실행되도록 함
    if (!event.target.checkValidity()) {
      return true // 기본 HTML5 validation을 실행하고 제출 중단
    }

    // 이메일 인증번호가 입력되었는지 확인
    const verificationCode = this.verificationInputTarget?.value
    if (this.emailSent && (!verificationCode || verificationCode.length !== 6)) {
      event.preventDefault()
      this.verificationStatusTarget.innerHTML = '<div class="text-sm text-red-600 dark:text-red-400">인증번호 6자리를 입력해주세요.</div>'
      this.verificationInputTarget.focus()
      return false
    }

    // 폼 제출 전 로딩 상태로 변경
    const submitButton = this.submitButtonTarget
    const originalText = submitButton.textContent
    
    submitButton.disabled = true
    submitButton.innerHTML = originalText + ' <svg class="animate-spin -mr-1 ml-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle><path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path></svg>'

    // 일반 폼 제출 진행 (새로고침 허용)
    return true
  }
}